$(document).ready(($) => {
  const $cards = $('.cards .card');

  $cards.on('mouseover', function(e) {
    const $this = $(e.currentTarget);
    const $btns = $this.find('.btn');

    $btns.addClass('hover');
  });

  $cards.on('mouseout', function(e) {
    const $this = $(e.currentTarget);
    const $btns = $this.find('.btn');

    $btns.removeClass('hover');
  });

});